<app-region-dropdown
  [options]="options"
  [(value)]="region"
  (valueChange)="onChangeRegion($event)"
  data-automationid="switchregion-dropdown"
/>

<joii-dialog
  class="switchregion-confirm-dialog"
  #confirmDialog
  [variant]="'flexible-sized-modal'"
  [headerOptions]="{ title: 'Switch Region?' }"
>
  <div class="pt-2">
    <p class="text-gray-500 text-sm font-normal leading-5 mb-3">
      You are about to switch to {{ regionFlag() }} {{ regionName() }}
    </p>
    <p class="text-gray-500 text-sm font-normal leading-5 mb-14">
      This will update all data throughout the portal to show {{ regionName() }} related information.
      <strong>Please save data before switching.</strong>
    </p>
  </div>
  <div dialog-footer>
    <div class="flex items-center gap-2 justify-end w-full">
      <button
        class="w-20 h-9 px-4 py-2 bg-white rounded-lg outline outline-1 outline-offset-[-1px] outline-black/10 inline-flex justify-center items-center gap-2 text-neutral-950 text-sm font-normal font-['Arial'] leading-5"
        (click)="cancelConfirmDialog()"
      >
        Cancel
      </button>
      <button
        class="w-32 h-9 px-4 py-2 bg-blue-800 rounded-lg inline-flex justify-center items-center gap-2 text-center text-white text-sm font-normal leading-5"
        (click)="refreshCurrentRoute(region())"
      >
        Switch Region
      </button>
    </div>
  </div>
</joii-dialog>
